import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { Order } from "@/types/types";

import { ScheduleState } from "@/types/schedule";

import { scheduleApi } from "./schedule.api";

const initialState: ScheduleState = {
	schedule: [],
	sortingSchedule: {
		sortBy: "createdAt",
		sortOrder: Order.ASC,
	},
	meta: {
		page: 1,
		limit: 15,
		itemCount: 15,
		pageCount: 1,
		hasPreviousPage: false,
		hasNextPage: false,
	},
};

export const scheduleSlice = createSlice({
	name: "schedule",
	initialState,
	reducers: {
		setScheduleSorting: (state, { payload }) => {
			if (
				state.sortingSchedule.sortOrder === Order.DESC &&
				payload.sortOrder === Order.ASC &&
				payload.sortBy === state.sortingSchedule.sortBy
			) {
				payload.sortBy = initialState.sortingSchedule.sortBy;
				payload.sortOrder = initialState.sortingSchedule.sortOrder;
			}

			state.sortingSchedule = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(scheduleApi.endpoints.sendMessage.matchFulfilled, (state, { payload }) => {
			// state.schedule = payload.data;
			// state.meta = payload.meta;
		});
		builder.addMatcher(scheduleApi.endpoints.sendMessages.matchFulfilled, (state, { payload }) => {
			// Unified endpoint — placeholder for future state updates
		});
	},
});

export const { setScheduleSorting } = scheduleSlice.actions;
export const scheduleReducer = scheduleSlice.reducer;
export const scheduleSelector = (state: RootState) => state[scheduleSlice.name];
